function getVariantUrl(formatProductUrl, product, variant, productType, additionalUrlParams) {
    if (!productType) {
        console.error(`ProductType data is missing from product with id ${product.id}, make sure you 'expand' the productType when fetching from commercetools.`, product);
        return '#';
    }
    if (!variant.sku) {
        console.error(`Variant for product with id ${product.id} has no sku`, {
            variant,
            product
        });
        return '#';
    }
    return formatProductUrl({
        productType,
        sku: variant.sku,
        slug: product.slug
    }, additionalUrlParams);
}

export { getVariantUrl };
//# sourceMappingURL=get-variant-url.js.map
